function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M6.413 1.235a.625.625 0 01.88-.075l2.672 2.25a.625.625 0 01.022.937L7.315 6.82a.625.625 0 11-.849-.918l1.501-1.39H5.203a2.75 2.75 0 00-2.75 2.75v4.5a2.75 2.75 0 002.75 2.75.625.625 0 110 1.25 4 4 0 01-4-4v-4.5a4 4 0 014-4H7.85L6.488 2.117a.625.625 0 01-.075-.88zM11.587 17.79a.625.625 0 01-.88.076l-2.672-2.25a.625.625 0 01-.022-.937l2.672-2.473a.625.625 0 01.849.917l-1.501 1.39h2.764a2.75 2.75 0 002.75-2.75v-4.5a2.75 2.75 0 00-2.75-2.75.625.625 0 110-1.25 4 4 0 014 4v4.5a4 4 0 01-4 4H10.15l1.362 1.147a.625.625 0 01.075.88z"
});

var SvgThreadsRepost = function SvgThreadsRepost(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-label": "Repost",
    viewBox: "0 0 18 18",
    fill: "#424242"
  }, props), _ref);
};

export default SvgThreadsRepost;